import { API_URL_PARTNER } from "@constants/env";
import apiInstance from "@services/Shared/instanceAxios";

const deleteItem = (uuid: string) =>
  apiInstance({
    url: API_URL_PARTNER + uuid,
    method: "delete",
  });

export default deleteItem;
